import { render, staticRenderFns } from "./realty.vue?vue&type=template&id=1545dea4&"
import script from "./realty.vue?vue&type=script&lang=js&"
export * from "./realty.vue?vue&type=script&lang=js&"
import style0 from "./realty.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports